
import React from 'react';

import type { Props } from './types';
import { Box } from '@chakra-ui/react';
import AppErrorBoundary from 'ui/shared/AppError/AppErrorBoundary';
import HeaderDesktop from 'ui/snippets/header/HeaderDesktop';
import HeaderMobile from 'ui/snippets/header/HeaderMobile';
import HeroBanner from 'ui/home/HeroBanner';

import * as Layout from './components';

const LayoutDefault = ({ children }: Props) => {
  return (
    <Layout.Container>
      <Layout.NavBar/>
      <HeaderMobile/>
      <Box pt="30px">
      <Layout.MainArea>
        <Layout.SideBar/>
        <Layout.MainColumn>
          <HeaderDesktop/>
          <AppErrorBoundary>
            <Layout.Content>
              <Box mt={ 7 } mb={ 7 }>
                <HeroBanner/>
              </Box>
              { children }
            </Layout.Content>
          </AppErrorBoundary>
        </Layout.MainColumn>
      </Layout.MainArea>
      </Box>
      <Layout.Footer/>
    </Layout.Container>
  );
};

export default LayoutDefault;
